import { Components, Theme } from '@mui/material';
import type {} from '@mui/x-date-pickers/themeAugmentation';

export const components: Components<Theme> = {
  MuiCssBaseline: {
    styleOverrides: {
      html: {
        height: '100%'
      },
      body: {
        height: '100%',
        padding: '12px 10px',

        '#__next': {
          //100vh height issue in mobile
          height: '100%',
          overflow: 'hidden'
        },
        '@media screen and (orientation: landscape)': {
          '#__next': {
            height: 'auto',
            overflow: 'auto'
          }
        }
      }
    }
  },
  MuiInputBase: {
    styleOverrides: {
      root: ({ theme }) => ({
        borderRadius: '2px 16px 16px 16px',

        '&.MuiInput-underline:before': {
          borderBottom: `1px solid ${theme.palette.grey[50]}`
        },

        textarea: {
          padding: '0'
        }
      })
    }
  },
  MuiInputLabel: {
    styleOverrides: {
      root: ({ theme }) => ({
        lineHeight: '30px',
        color: theme.palette.grey[200],

        '&.-shrink.Mui-error': {
          borderColor: theme.palette.error.main
        },
        '&.Mui-focused': {
          color: theme.palette.grey[200]
        }
      })
    }
  },
  MuiFormHelperText: {
    styleOverrides: {
      root: () => ({
        margin: '0'
      })
    }
  },
  MuiFormLabel: {
    styleOverrides: {
      root: ({ theme }) => ({
        '&.MuiInputLabel-root.Mui-error': {
          color: theme.palette.grey[200]
        },
        '&.MuiInputLabel-root.Mui-error.MuiInputLabel-shrink': {
          color: theme.palette.error.main
        }
      })
    }
  },
  MuiTypography: {
    styleOverrides: {
      root: () => ({
        '&.MuiDayPicker-weekDayLabel': {
          color: 'unset'
        }
      })
    }
  },
  MuiPickersDay: {
    styleOverrides: {
      root: ({ theme }) => ({
        '&.Mui-selected': {
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.common.white
        },
        '&.MuiPickersDay-today': {
          border: '1px solid unset'
        }
      })
    }
  },
  MuiMonthPicker: {
    styleOverrides: {
      root: ({ theme }) => ({
        ' .PrivatePickersMonth-root:disabled': {
          color: 'unset'
        },

        '& .PrivatePickersMonth-root.Mui-disabled': {
          color: 'unset'
        },

        '& .PrivatePickersMonth-root.Mui-selected': {
          color: theme.palette.common.white
        }
      })
    }
  },
  MuiYearPicker: {
    styleOverrides: {
      root: ({ theme }) => ({
        '& .PrivatePickersYear-yearButton.Mui-disabled': {
          color: 'unset'
        },

        '& .PrivatePickersYear-yearButton.Mui-selected': {
          color: theme.palette.common.white
        }
      })
    }
  },
  MuiPickersCalendarHeader: {
    styleOverrides: {
      root: () => ({
        '& .MuiPickersCalendarHeader-switchViewButton': {
          width: 'fit-content',
          height: 'fit-content'
        }
      })
    }
  },
  MuiLinearProgress: {
    styleOverrides: {
      root: () => ({
        position: 'fixed',
        width: '100%',
        top: 0,
        left: 0,
        zIndex: 3
      })
    }
  },
  MuiCheckbox: {
    defaultProps: {
      disableRipple: true
    },
    styleOverrides: {
      root: ({ theme }) => ({
        backgroundColor: 'transparent',
        padding: 0,
        margin: theme.spacing(0, 8, 0, 0),
        height: 'fit-content',

        div: {
          transition: 'all 0.2s ease-in-out'
        },

        '&.Mui-checked': {
          div: {
            borderColor: theme.palette.primary.main,
            backgroundColor: theme.palette.primary.main
          },
          '&:hover': {
            div: {
              borderColor: theme.palette.primary.dark,
              backgroundColor: theme.palette.primary.dark
            }
          }
        },

        '&.MuiCheckbox-colorError': {
          div: {
            borderColor: theme.palette.error.main
          }
        }
      })
    }
  },
  MuiRadio: {
    defaultProps: {
      disableRipple: true
    },
    styleOverrides: {
      root: ({ theme }) => ({
        padding: 0,
        backgroundColor: 'transparent',

        '&:hover': {
          backgroundColor: 'transparent',

          div: {
            borderColor: theme.palette.primary.dark
          },

          '&.Mui-checked': {
            div: {
              backgroundColor: theme.palette.primary.dark
            }
          }
        }
      })
    }
  },
  MuiButtonBase: {
    defaultProps: {
      disableRipple: true
    }
  }
};
